(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
$( document ).ready(function(event) {

  
  	$('.announcement-bar-slider').slick({
 		dots: false,
  		infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 2000,
        slidesToShow: 1,
        arrows:false
	});
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup-aug"]) return;
  try {
    

  $(document).ready(function() {
    $(".sectionLink.newsletter-signup").click(function() { $(".newsletter-box").show(); });
    $(".close-newletter-box").click(function() { $(".newsletter-box").hide(); });
  });

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      if (window.innerWidth <= 749 && window.location.pathname.includes('/products/')) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal() { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ─────────────────────────────────────────
     MOBILE SEARCH — custom fetch, no Shopify predictive
  ───────────────────────────────────────── */
  (function() {
    var trigger   = document.getElementById('lo-search-trigger');
    var panel     = document.getElementById('lo-search-panel');
    var closeBtn  = document.getElementById('lo-sp-close');
    var input     = document.getElementById('lo-sp-input');
    var defaultEl = document.getElementById('lo-sp-default');
    var resultsEl = document.getElementById('lo-sp-results');
    var gridEl    = document.getElementById('lo-sp-grid');
    var loadingEl = document.getElementById('lo-sp-loading');
    var emptyEl   = document.getElementById('lo-sp-empty');

    if (!trigger || !panel) return;

    var debounceTimer = null;
    var currentQuery  = '';

    var scrollY = 0;

    function openPanel() {
      scrollY = window.scrollY || window.pageYOffset;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      // Lock body scroll (iOS fix)
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      setTimeout(function() { if (input) input.focus(); }, 80);
    }

    function closePanel() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      // Restore body scroll
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
      if (input) input.value = '';
      currentQuery = '';
      showDefault();
    }

    function showDefault() {
      defaultEl.classList.remove('is-hidden');
      resultsEl.classList.remove('is-visible');
    }

    function showResults() {
      defaultEl.classList.add('is-hidden');
      resultsEl.classList.add('is-visible');
    }

    function formatMoney(amount) {
      return '&#8369;' + parseFloat(amount).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderResults(products, queries) {
      gridEl.innerHTML = '';
      loadingEl.style.display = 'none';
      emptyEl.style.display   = 'none';

      var hasProducts = products && products.length > 0;
      var hasQueries  = queries && queries.length > 0;

      if (!hasProducts && !hasQueries) {
        emptyEl.style.display = 'block';
        return;
      }

      // Dynamic query suggestions — same style as static default
      if (hasQueries) {
        var sugWrap = document.createElement('div');
        sugWrap.className = 'lo-sp-dyn-suggestions';

        var label = document.createElement('p');
        label.className = 'lo-sp-label';
        label.textContent = 'Suggestions:';
        sugWrap.appendChild(label);

        var divider = document.createElement('hr');
        divider.className = 'lo-sp-divider';
        sugWrap.appendChild(divider);

        var ul = document.createElement('ul');
        ul.className = 'lo-sp-suggestions';
        queries.slice(0, 6).forEach(function(q) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '/search?q=' + encodeURIComponent(q.text) + '&options[prefix]=last';
          a.className = 'lo-sp-sug-link';
          a.textContent = q.text || '';
          li.appendChild(a);
          ul.appendChild(li);
        });
        sugWrap.appendChild(ul);
        gridEl.appendChild(sugWrap);
      }

      // Product grid — wrapped separately so it sits below suggestions
      if (hasProducts) {
        var prodWrap = document.createElement('div');
        prodWrap.className = 'lo-sp-results-grid';
        products.forEach(function(p) {
          var imgSrc = p.image ? p.image.replace(/(\.[^.]+)$/, '_300x300$1') : '';
          var price  = p.price ? formatMoney(p.price) : '';
          var card   = document.createElement('a');
          card.href  = p.url;
          card.className = 'lo-sp-result';
          var cleanTitle = (p.title || '').split(' |')[0].trim();
          card.innerHTML =
            '<div class="lo-sp-result__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + cleanTitle.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</div>' +
            '<p class="lo-sp-result__title">' + cleanTitle + '</p>' +
            '<p class="lo-sp-result__price">' + price + '</p>';
          prodWrap.appendChild(card);
        });
        gridEl.appendChild(prodWrap);
      }
    }

    function fetchResults(q) {
      if (!q || q.trim() === '') { showDefault(); return; }
      showResults();
      gridEl.innerHTML   = '';
      loadingEl.style.display = 'block';
      emptyEl.style.display   = 'none';

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== currentQuery) return; // stale response
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var queries  = (data.resources && data.resources.results && data.resources.results.queries) || [];
          renderResults(products, queries);
        })
        .catch(function() {
          if (q !== currentQuery) return;
          loadingEl.style.display = 'none';
          emptyEl.style.display   = 'block';
        });
    }

    trigger.addEventListener('click', openPanel);

    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    if (input) {
      input.addEventListener('input', function() {
        var q = this.value.trim();
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q === '') { showDefault(); return; }
        debounceTimer = setTimeout(function() { fetchResults(q); }, 250);
      });

      // Allow pressing Enter to go to full search results page
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          var q = document.getElementById('lo-sp-input').value.trim();
          if (q) { window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });
  })();

  /* ─────────────────────────────────────────
     DESKTOP SEARCH — full-width overlay panel
     Click on header search input → opens panel covering header
     All typing happens in panelInput inside the panel bar
  ───────────────────────────────────────── */
  (function() {
    var headerInput = { value: '' }; // placeholder lang, wala nang input sa header
    var dtPanel     = document.getElementById('lo-dt-panel');
    var panelInput  = document.getElementById('lo-dt-panel-input');
    var dtClose     = document.getElementById('lo-dt-close');
    var dtDefault   = document.getElementById('lo-dt-default');
    var dtResults   = document.getElementById('lo-dt-results');
    var dtSugCol    = document.getElementById('lo-dt-sug-col');
    var dtGrid      = document.getElementById('lo-dt-grid');
    var dtLoading   = document.getElementById('lo-dt-loading');
    var dtEmpty     = document.getElementById('lo-dt-empty');

    if (!headerInput || !dtPanel || !panelInput) return;

    var dtDebounce = null;
    var dtQuery    = '';
    var isOpen     = false;

    /* ── Open / close ── */
    function dtOpen() {
      if (isOpen) return;
      isOpen = true;
      dtPanel.classList.add('is-open');
      dtPanel.removeAttribute('aria-hidden');
      
      // Lock body scroll
      document.body.classList.add('dt-search-open');
      
      // Sync any pre-typed value, then focus panel input
      panelInput.value = headerInput.value;
      dtQuery = panelInput.value.trim();
      setTimeout(function() {
        panelInput.focus();
        var len = panelInput.value.length;
        try { panelInput.setSelectionRange(len, len); } catch(e) {}
        // Show default or kick off search if value already present
        if (dtQuery === '') {
          dtShowDefault();
        } else {
          dtFetch(dtQuery);
        }
      }, 20);
    }

    function dtClose_() {
      if (!isOpen) return;
      isOpen = false;
      dtPanel.classList.remove('is-open');
      dtPanel.setAttribute('aria-hidden', 'true');
      
      // Unlock body scroll
      document.body.classList.remove('dt-search-open');
      
      // Reset
      panelInput.value  = '';
      dtQuery = '';
      dtShowDefault();
    }

    function dtShowDefault() {
      if (!dtDefault || !dtResults) return;
      dtDefault.classList.remove('is-hidden');
      dtResults.classList.remove('is-visible');
    }

    function dtShowResults() {
      if (!dtDefault || !dtResults) return;
      dtDefault.classList.add('is-hidden');
      dtResults.classList.add('is-visible');
    }

    function dtFormatMoney(amount) {
      return '&#8369;' + parseFloat(amount).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function dtRenderResults(products, queries) {
      dtSugCol.innerHTML = '';
      dtGrid.innerHTML   = '';
      if (dtLoading) dtLoading.style.display = 'none';
      if (dtEmpty)   dtEmpty.style.display   = 'none';

      var hasProducts = products && products.length > 0;
      var hasQueries  = queries  && queries.length  > 0;

      if (!hasProducts && !hasQueries) {
        if (dtEmpty) dtEmpty.style.display = 'block';
        return;
      }

      /* Left col: query suggestions */
      if (hasQueries) {
        var label = document.createElement('p');
        label.className = 'lo-dt-label';
        label.textContent = 'Suggestions:';
        dtSugCol.appendChild(label);

        var hr = document.createElement('hr');
        hr.className = 'lo-dt-divider';
        dtSugCol.appendChild(hr);

        var ul = document.createElement('ul');
        ul.className = 'lo-dt-dyn-suggestions';
        queries.slice(0, 6).forEach(function(q) {
          var li = document.createElement('li');
          var a  = document.createElement('a');
          a.href = '/search?q=' + encodeURIComponent(q.text) + '&options[prefix]=last';
          a.textContent = q.text || '';
          li.appendChild(a);
          ul.appendChild(li);
        });
        dtSugCol.appendChild(ul);
      }

      /* Right col: product grid */
      if (hasProducts) {
        var grid = document.createElement('div');
        grid.className = 'lo-dt-results-grid';
        products.forEach(function(p) {
          var imgSrc = p.image ? p.image.replace(/(\.[^.]+)$/, '_400x400$1') : '';
          var price  = p.price ? dtFormatMoney(p.price) : '';
          var card   = document.createElement('a');
          card.href  = p.url;
          card.className = 'lo-dt-result';
          var cleanTitle = (p.title || '').split(' |')[0].trim();
          card.innerHTML =
            '<div class="lo-dt-result__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<p class="lo-dt-result__title">' + cleanTitle + '</p>' +
            '<p class="lo-dt-result__price">' + price + '</p>';
          grid.appendChild(card);
        });
        dtGrid.appendChild(grid);
      }
    }

    function dtFetch(q) {
      if (!q) { dtShowDefault(); return; }
      dtShowResults();
      dtSugCol.innerHTML = '';
      dtGrid.innerHTML   = '';
      if (dtLoading) { dtLoading.style.display = 'block'; dtSugCol.appendChild(dtLoading); }
      if (dtEmpty)     dtEmpty.style.display   = 'none';

      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== dtQuery) return;
          var prods   = (data.resources && data.resources.results && data.resources.results.products) || [];
          var queries = (data.resources && data.resources.results && data.resources.results.queries)  || [];
          dtRenderResults(prods, queries);
        })
        .catch(function() {
          if (q !== dtQuery) return;
          if (dtLoading) dtLoading.style.display = 'none';
          if (dtEmpty)   dtEmpty.style.display   = 'block';
        });
    }

    /* ── Header input: focus opens the panel ── */

    var dtIconBtn = document.getElementById('lo-dt-search-icon-btn');
    if (dtIconBtn) {
      dtIconBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!isOpen) dtOpen();
      });
    }

    /* ── Panel input drives the search ── */
    panelInput.addEventListener('input', function() {
      var q = this.value.trim();
      dtQuery = q;
      headerInput.value = this.value; // keep header in sync
      clearTimeout(dtDebounce);
      if (q === '') { dtShowDefault(); return; }
      dtDebounce = setTimeout(function() { dtFetch(q); }, 250);
    });

    panelInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        var q = document.getElementById('lo-dt-panel-input').value.trim();
        if (q) { dtClose_(); window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
      }
      if (e.key === 'Escape') dtClose_();
    });

    /* ── Close button ── */
    if (dtClose) {
      dtClose.addEventListener('click', function(e) {
        e.preventDefault();
        dtClose_();
      });
    }

    /* ── Outside click closes panel ── */
    document.addEventListener('mousedown', function(e) {
      if (!isOpen) return;
      if (dtPanel.contains(e.target)) return;
      dtClose_();
    });

    /* ── Escape globally ── */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) dtClose_();
    });

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-backup"]) return;
  try {
    


  $(document).ready(function() {
  $(".sectionLink.newsletter-signup").click(function() {
    $(".newsletter-box").show();
  });
           
  $(".close-newletter-box").click(function() {
    $(".newsletter-box").hide();
  });

    // window.onload = function () {
    //   setTimeout(function() {
    //     if (localStorage.getItem("hasCodeRunBefore") === null) {
    //       $(".sectionLink.newsletter-signup").trigger( "click" );
    //       localStorage.setItem("hasCodeRunBefore", true);
    //     }
    //   }, 10000);
    // }
});
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      /*lo-vince-added*/
      if (window.innerWidth <= 749 && window.location.pathname.includes('/products/')) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  $(document).ready(function() {
    $(".sectionLink.newsletter-signup").click(function() { $(".newsletter-box").show(); });
    $(".close-newletter-box").click(function() { $(".newsletter-box").hide(); });
  });

  /* Color SALE menu item red */
  document.querySelectorAll('.header__inline-menu .list-menu--inline > li').forEach(function(li) {
    var span = li.querySelector('.header__menu-item span');
    if (span && span.textContent.trim().toUpperCase() === 'SALE') {
      span.style.color = '#cc0921';
    }
  });

  /* Force nested dropdown column headers to stay open always */
  document.querySelectorAll('.header__submenu.list-menu--disclosure > li > details').forEach(function (d) {
    d.setAttribute('open', '');
  });

  /* Keep dropdown panel aligned to header bottom + left-align to nav start */
  function updateLoMegaMenuOffset() {
    var wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;
    var bottom = wrapper.getBoundingClientRect().bottom;
    document.documentElement.style.setProperty('--lo-header-bottom', Math.max(bottom, 0) + 'px');
    var nav = document.querySelector('.header__inline-menu');
    if (nav) {
      var navLeft = nav.getBoundingClientRect().left + 10; /* extra push right, adjust value as needed */
      document.documentElement.style.setProperty('--lo-menu-left', Math.max(navLeft, 0) + 'px');
    }
  }
  updateLoMegaMenuOffset();
  window.addEventListener('resize', updateLoMegaMenuOffset);
  window.addEventListener('scroll', updateLoMegaMenuOffset, { passive: true });

  /* Hover-to-open for top-level dropdown menu items + click navigates to link */
  document.querySelectorAll('.header__inline-menu > .list-menu--inline > li').forEach(function (li) {
    var details = li.querySelector(':scope > header-menu > details');
    if (!details) return;

    var closeTimer;

    li.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      updateLoMegaMenuOffset();
      details.setAttribute('open', '');
    });

    li.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, 150);
    });

    /* Click on top-level summary → navigate to its collection/page */
    var summary = details.querySelector(':scope > summary');
    if (summary) {
      var url = summary.getAttribute('data-lo-link');
      if (url && url !== '#') {
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          window.location.href = url;
        });
      }
    }
  });

  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      if (window.innerWidth <= 749 && window.location.pathname.includes('/products/')) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) { requestAnimationFrame(this.reveal.bind(this)); }
        else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure(); this.closeSearchModal();
    }
    reveal() { this.header.classList.add('shopify-section-header-sticky', 'animate'); this.header.classList.remove('shopify-section-header-hidden'); }
    reset() { this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate'); }
    closeMenuDisclosure() { this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu'); this.disclosures.forEach(d => d.close()); }
    closeSearchModal() { this.searchModal = this.searchModal || this.header.querySelector('details-modal'); this.searchModal.close(false); }
  }
  customElements.define('sticky-header', StickyHeader);

  /* ─── MOBILE SEARCH ─── */
  (function() {
    var trigger   = document.getElementById('lo-search-trigger');
    var panel     = document.getElementById('lo-search-panel');
    var closeBtn  = document.getElementById('lo-sp-close');
    var input     = document.getElementById('lo-sp-input');
    var defaultEl = document.getElementById('lo-sp-default');
    var resultsEl = document.getElementById('lo-sp-results');
    var gridEl    = document.getElementById('lo-sp-grid');
    var loadingEl = document.getElementById('lo-sp-loading');
    var emptyEl   = document.getElementById('lo-sp-empty');

    if (!trigger || !panel) return;

    var debounceTimer = null;
    var currentQuery  = '';
    var scrollY = 0;

    function openPanel() {
      scrollY = window.scrollY || window.pageYOffset;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      setTimeout(function() { if (input) input.focus(); }, 80);
    }

    function closePanel() {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
      if (input) input.value = '';
      currentQuery = '';
      showDefault();
    }

    function showDefault() { defaultEl.classList.remove('is-hidden'); resultsEl.classList.remove('is-visible'); }
    function showResults() { defaultEl.classList.add('is-hidden'); resultsEl.classList.add('is-visible'); }

    function formatMoney(amount) {
      return '&#8369;' + parseFloat(amount).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function renderResults(products, queries) {
      gridEl.innerHTML = '';
      loadingEl.style.display = 'none';
      emptyEl.style.display = 'none';
      var hasProducts = products && products.length > 0;
      var hasQueries  = queries && queries.length > 0;
      if (!hasProducts && !hasQueries) { emptyEl.style.display = 'block'; return; }
      if (hasQueries) {
        var sugWrap = document.createElement('div');
        sugWrap.className = 'lo-sp-dyn-suggestions';
        var label = document.createElement('p');
        label.className = 'lo-sp-label';
        label.textContent = 'Suggestions:';
        sugWrap.appendChild(label);
        var divider = document.createElement('hr');
        divider.className = 'lo-sp-divider';
        sugWrap.appendChild(divider);
        var ul = document.createElement('ul');
        ul.className = 'lo-sp-suggestions';
        queries.slice(0, 6).forEach(function(q) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '/search?q=' + encodeURIComponent(q.text) + '&options[prefix]=last';
          a.className = 'lo-sp-sug-link';
          a.textContent = q.text || '';
          li.appendChild(a);
          ul.appendChild(li);
        });
        sugWrap.appendChild(ul);
        gridEl.appendChild(sugWrap);
      }
      if (hasProducts) {
        var prodWrap = document.createElement('div');
        prodWrap.className = 'lo-sp-results-grid';
        products.forEach(function(p) {
          var imgSrc = p.image ? p.image.replace(/(\.[^.]+)$/, '_300x300$1') : '';
          var price  = p.price ? formatMoney(p.price) : '';
          var card   = document.createElement('a');
          card.href  = p.url;
          card.className = 'lo-sp-result';
          var cleanTitle = (p.title || '').split(' |')[0].trim();
          card.innerHTML =
            '<div class="lo-sp-result__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + cleanTitle.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</div>' +
            '<p class="lo-sp-result__title">' + cleanTitle + '</p>' +
            '<p class="lo-sp-result__price">' + price + '</p>';
          prodWrap.appendChild(card);
        });
        gridEl.appendChild(prodWrap);
      }
    }

    function fetchResults(q) {
      if (!q || q.trim() === '') { showDefault(); return; }
      showResults();
      gridEl.innerHTML = '';
      loadingEl.style.display = 'block';
      emptyEl.style.display = 'none';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== currentQuery) return;
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          var queries  = (data.resources && data.resources.results && data.resources.results.queries) || [];
          renderResults(products, queries);
        })
        .catch(function() {
          if (q !== currentQuery) return;
          loadingEl.style.display = 'none';
          emptyEl.style.display = 'block';
        });
    }

    trigger.addEventListener('click', openPanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    if (input) {
      input.addEventListener('input', function() {
        var q = this.value.trim();
        currentQuery = q;
        clearTimeout(debounceTimer);
        if (q === '') { showDefault(); return; }
        debounceTimer = setTimeout(function() { fetchResults(q); }, 250);
      });
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          var q = document.getElementById('lo-sp-input').value.trim();
          if (q) { window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
        }
      });
    }
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });
  })();

  /* ─── DESKTOP SEARCH ─── */
  (function() {
    var headerInput = { value: '' };
    var dtPanel     = document.getElementById('lo-dt-panel');
    var panelInput  = document.getElementById('lo-dt-panel-input');
    var dtClose     = document.getElementById('lo-dt-close');
    var dtDefault   = document.getElementById('lo-dt-default');
    var dtResults   = document.getElementById('lo-dt-results');
    var dtSugCol    = document.getElementById('lo-dt-sug-col');
    var dtGrid      = document.getElementById('lo-dt-grid');
    var dtLoading   = document.getElementById('lo-dt-loading');
    var dtEmpty     = document.getElementById('lo-dt-empty');

    if (!headerInput || !dtPanel || !panelInput) return;

    var dtDebounce = null;
    var dtQuery    = '';
    var isOpen     = false;

    function dtOpen() {
      if (isOpen) return;
      isOpen = true;
      dtPanel.classList.add('is-open');
      dtPanel.removeAttribute('aria-hidden');
      document.body.classList.add('dt-search-open');
      panelInput.value = headerInput.value;
      dtQuery = panelInput.value.trim();
      setTimeout(function() {
        panelInput.focus();
        var len = panelInput.value.length;
        try { panelInput.setSelectionRange(len, len); } catch(e) {}
        if (dtQuery === '') { dtShowDefault(); } else { dtFetch(dtQuery); }
      }, 20);
    }

    function dtClose_() {
      if (!isOpen) return;
      isOpen = false;
      dtPanel.classList.remove('is-open');
      dtPanel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dt-search-open');
      panelInput.value = '';
      dtQuery = '';
      dtShowDefault();
    }

    function dtShowDefault() {
      if (!dtDefault || !dtResults) return;
      dtDefault.classList.remove('is-hidden');
      dtResults.classList.remove('is-visible');
    }

    function dtShowResults() {
      if (!dtDefault || !dtResults) return;
      dtDefault.classList.add('is-hidden');
      dtResults.classList.add('is-visible');
    }

    function dtFormatMoney(amount) {
      return '&#8369;' + parseFloat(amount).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function dtRenderResults(products, queries) {
      dtSugCol.innerHTML = '';
      dtGrid.innerHTML   = '';
      if (dtLoading) dtLoading.style.display = 'none';
      if (dtEmpty)   dtEmpty.style.display   = 'none';
      var hasProducts = products && products.length > 0;
      var hasQueries  = queries  && queries.length  > 0;
      if (!hasProducts && !hasQueries) { if (dtEmpty) dtEmpty.style.display = 'block'; return; }
      if (hasQueries) {
        var label = document.createElement('p');
        label.className = 'lo-dt-label';
        label.textContent = 'Suggestions:';
        dtSugCol.appendChild(label);
        var hr = document.createElement('hr');
        hr.className = 'lo-dt-divider';
        dtSugCol.appendChild(hr);
        var ul = document.createElement('ul');
        ul.className = 'lo-dt-dyn-suggestions';
        queries.slice(0, 6).forEach(function(q) {
          var li = document.createElement('li');
          var a  = document.createElement('a');
          a.href = '/search?q=' + encodeURIComponent(q.text) + '&options[prefix]=last';
          a.textContent = q.text || '';
          li.appendChild(a);
          ul.appendChild(li);
        });
        dtSugCol.appendChild(ul);
      }
      if (hasProducts) {
        var grid = document.createElement('div');
        grid.className = 'lo-dt-results-grid';
        products.forEach(function(p) {
          var imgSrc = p.image ? p.image.replace(/(\.[^.]+)$/, '_400x400$1') : '';
          var price  = p.price ? dtFormatMoney(p.price) : '';
          var card   = document.createElement('a');
          card.href  = p.url;
          card.className = 'lo-dt-result';
          var cleanTitle = (p.title || '').split(' |')[0].trim();
          card.innerHTML =
            '<div class="lo-dt-result__img">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="" loading="lazy">' : '') +
            '</div>' +
            '<p class="lo-dt-result__title">' + cleanTitle + '</p>' +
            '<p class="lo-dt-result__price">' + price + '</p>';
          grid.appendChild(card);
        });
        dtGrid.appendChild(grid);
      }
    }

    function dtFetch(q) {
      if (!q) { dtShowDefault(); return; }
      dtShowResults();
      dtSugCol.innerHTML = '';
      dtGrid.innerHTML   = '';
      if (dtLoading) { dtLoading.style.display = 'block'; dtSugCol.appendChild(dtLoading); }
      if (dtEmpty)     dtEmpty.style.display   = 'none';
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,query&resources[limit]=4&resources[options][unavailable_products]=last')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (q !== dtQuery) return;
          var prods   = (data.resources && data.resources.results && data.resources.results.products) || [];
          var queries = (data.resources && data.resources.results && data.resources.results.queries)  || [];
          dtRenderResults(prods, queries);
        })
        .catch(function() {
          if (q !== dtQuery) return;
          if (dtLoading) dtLoading.style.display = 'none';
          if (dtEmpty)   dtEmpty.style.display   = 'block';
        });
    }

    var dtIconBtn = document.getElementById('lo-dt-search-icon-btn');
    if (dtIconBtn) {
      dtIconBtn.addEventListener('click', function(e) {
        e.preventDefault();
        if (!isOpen) dtOpen();
      });
    }

    panelInput.addEventListener('input', function() {
      var q = this.value.trim();
      dtQuery = q;
      headerInput.value = this.value;
      clearTimeout(dtDebounce);
      if (q === '') { dtShowDefault(); return; }
      dtDebounce = setTimeout(function() { dtFetch(q); }, 250);
    });

    panelInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        var q = document.getElementById('lo-dt-panel-input').value.trim();
        if (q) { dtClose_(); window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
      }
      if (e.key === 'Escape') dtClose_();
    });

    if (dtClose) {
      dtClose.addEventListener('click', function(e) {
        e.preventDefault();
        dtClose_();
      });
    }

    document.addEventListener('mousedown', function(e) {
      if (!isOpen) return;
      if (dtPanel.contains(e.target)) return;
      dtClose_();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isOpen) dtClose_();
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-collection-categories"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
    $('.dc-collection-sliders').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows:true,
      prevArrow:"<button type='button' class='slick-prev pull-left'> < </button>",
      nextArrow:"<button type='button' class='slick-next pull-right'> > </button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  
});
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-featuring-the-best"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
    $('.ftb-collection-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      swiping: true,
      swipeToSlide:true,
      arrows:false,
      prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
      nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>",
      responsive: [
         {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  
});

//ADJUST HEIGHT 
let maxHeight = 0,
	items = $('.image-description');
 
items.each(function () {
    maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight); 
});
 
//Assign maximum height to children 
items.height(maxHeight);
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-featuring-the-best_backup_11222022"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
    $('.ftb-collection-slider').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      swiping: true,
      swipeToSlide:true,
      arrows:false,
      prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
      nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>",
      responsive: [
         {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  
  
});

//ADJUST HEIGHT 
let maxHeight = 0,
	items = $('.image-description');
 
items.each(function () {
    maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight); 
});
 
//Assign maximum height to children 
items.height(maxHeight);
 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-main-collection"] && !Shopify.designMode) return;
  try {
    
/*
$( document ).ready(function() {
    $('.dc-collection-slider-mo').slick({
 		dots: false,
        arrows: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 2,
  		slidesToScroll: 2,
        arrows:true,
        prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
        nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>",
  		responsive: [
    		{
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
  		]
	});
});*/

$( document ).ready(function() {
  	$('.dc-slider').slick({
        infinite: false,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: true,
        responsive: [
    		{
              breakpoint: 800,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            }
  		]
	});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  $( document ).ready(function() {

    	$(".modal-open").click(function (e) {

                  e.preventDefault();



          var modalId = $(this).attr("data-modal");
          $(".modal").removeClass("active");
              $(".overlay").addClass("active");
          		$("#"+modalId).addClass("active");
          	});



      $(".modal-close").click(function () {
        $(".overlay").removeClass("active");
        $(".modal").removeClass("active");
      });
      $('.ftb-collection-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        swiping: true,
        swipeToSlide:true,
        arrows:false,
        prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
        nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>",
        responsive: [
           {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

  });




  //ADJUST HEIGHT
  let maxHeight = 0,
  	items = $('.image-description');

  items.each(function () {
      maxHeight = ($(this).height() > maxHeight ? $(this).height() : maxHeight);
  });

  //Assign maximum height to children
  items.height(maxHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lo-section-sub-categories"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {
  	$('.Slider-subcategories-reebok-mo').slick({
 		dots: false,
  		infinite: true,
  		speed: 300,
  		slidesToShow: 2,
  		slidesToScroll: 2,
        arrows:true,
        prevArrow:"<button type='button' class='slick-prev pull-left'> &#9666; </button>",
        nextArrow:"<button type='button' class='slick-next pull-right'> &#9656; </button>"
	});
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
